import { render, staticRenderFns } from "./UserRecord.vue?vue&type=template&id=68455dfd&scoped=true&"
import script from "./UserRecord.vue?vue&type=script&lang=js&"
export * from "./UserRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68455dfd",
  null
  
)

export default component.exports